import type { DashBoardHeaderConfig, HeaderContent } from "./types";

const ROOT_LABEL = "Compliance dashboard";

export const toHeaderContent = (config: DashBoardHeaderConfig): HeaderContent => {
  if (config.variant === "arena") {
    return {
      breadcrumbs: [],
      title: ROOT_LABEL,
      subtitle: "All investment entities",
    };
  }

  if (config.variant === "entity") {
    return {
      breadcrumbs: [{ label: ROOT_LABEL, onClick: config.onRootClick }],
      title: config.entityName ?? "--",
      subtitle: "Investment entity",
    };
  }

  return {
    breadcrumbs: [
      { label: ROOT_LABEL, onClick: config.onRootClick },
      { label: config.entityName ?? "--", onClick: config.onEntityClick },
    ],
    title: config.positionName,
    subtitle: `Position in ${config.entityName}`,
  };
};
